import type { Ref, RefObject } from "react";

export function multiref<T>(...refs: (Ref<NoInfer<T>> | RefObject<NoInfer<T>> | undefined)[]): Ref<T> {
  return (val: T | null) => {
    for (const ref of refs) {
      if (!ref) continue;
      if (typeof ref === "function") ref(val);
      if (typeof ref === "object") ref.current = val;
    }
  };
}
